<script lang="ts">
  import loadingStore from '@/pages/preview/loading-store';
  import type {HelpInformation} from '@/types/settings';
  import HelpSlideOver from '../aside/HelpSlideOver.svelte';
  import {onDestroy, onMount, tick} from 'svelte';
  import {helpStore} from '@/store';

  export let className: string = '';
  export let fullSidebar: boolean = false;
  export let fullHeight: boolean = false;
  export let noheight: boolean = false;
  let loadMore: Boolean = false;
  let container: HTMLDivElement;
  let showSidePanel = false;
  let helpItem: HelpInformation | undefined;
  let width = 300;

  const checkScrollEvent = (e: Event) => {
    const target = e.target as Element;
    const {scrollHeight, scrollTop, clientHeight} = target;

    loadMore = Math.abs(scrollHeight - scrollTop - 2) <= Math.abs(clientHeight);
  };

  const getHContent = () => {
    if (noheight) return '';
    if (fullHeight) return 'h-full';
    return 'h-content-no-banner';
  };

  const getHelpInformation = async () => {
    await helpStore.getHelpInformation().then(response => {
      appendToggles();
    });
  };

  const toggleSidePanel = async (item?: HelpInformation) => {
    if (item == null || item == undefined) {
      helpItem = undefined;
      showSidePanel = false;
    } else {
      helpItem = item;
      showSidePanel = true;
    }
  };

  const appendToggles = async () => {
    if ($helpStore.items.length > 0) {
      $helpStore.items.forEach(item => {
        let parent = document.getElementById(item.divId) || null;
        if (!parent) return;

        let dot = Object.assign(document.createElement('div'), {
          className: 'fa-solid fa-circle-info ml-2 cursor-pointer text-gray-300',
          onclick: () => toggleSidePanel(item)
        });

        parent.classList.add('relative');
        parent.appendChild(dot);

        if (!item.isHighlighted) return;

        let pulsingDot = Object.assign(document.createElement('div'), {
          className: 'dot animate-ping',
          onclick: () => toggleSidePanel(item)
        });
        parent.appendChild(pulsingDot);
      });
    }
  };

  const toggleAside = async () => {
    showSidePanel = !showSidePanel;
  };

  const helpSubscription = helpStore.subscribe(help => {
    if (help.activeId != null) {
      let activeItem = $helpStore.items.filter(item => {
        return item.divId == help.activeId;
      });

      toggleSidePanel(activeItem[0]);
    }
  });

  // onMount(() => {
  //     getHelpInformation();
  // });

  onDestroy(() => {
    helpSubscription();
  });

  $: $loadingStore, getHelpInformation();
</script>

<main class="relative flex w-full flex-grow flex-col">
  <div
    bind:this={container}
    on:scroll={checkScrollEvent}
    id="container"
    class="overflow-none relative {className} {getHContent()}"
  >
    <slot {loadMore} />

    {#if showSidePanel}
      <HelpSlideOver content={helpItem} {width} on:toggle-aside={toggleAside} />
    {/if}
  </div>
</main>

<style>
  .h-content-no-banner {
    height: calc(100svh - 5rem);
  }
  @media (max-width: 1024px) {
    .h-content-no-banner {
      height: calc(100svh - 15rem);
    }
  }
  .h-content {
    height: 100vh;
    height: 100svh;
  }
</style>
